import { render } from "./CadastroModulo.vue?vue&type=template&id=3e7dbf2b&ts=true"
import script from "./CadastroModulo.vue?vue&type=script&lang=ts"
export * from "./CadastroModulo.vue?vue&type=script&lang=ts"

import exportComponent from "/home/arthur/ProjetoVue/revista/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__